import { FairUseOpsCard } from "./fair-use-ops-card"

/**
 * Drift — the daily half of fair use: who is spending, and which requests are
 * waiting for an answer.
 *
 * It is the card that used to sit under Usage & cost → Costs, moved here
 * unchanged. The per-row plan select it carried moved the other way, onto
 * Users & licences, where the rest of a person's licence lives.
 */
export function FairUseTabDrift() {
  return <FairUseOpsCard />
}
